import {Component, HostBinding, OnInit} from '@angular/core';
import {HttpService} from 'app/core/services/http.service';
import {environment as env} from 'environments/environment';
import {SettingsProvider} from 'app/core';
import {Observable} from 'rxjs';

@Component({
  selector: 'pr-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {

    @HostBinding('class') classes = 'flex flex-grow';

    reportNames$: Observable<string[]>;

    constructor(private http: HttpService,
                private serviceSettings: SettingsProvider) { }

  ngOnInit(): void {
        const url = `${this.serviceSettings.configuration.url}${env.RaportsService.apiUrlGetList}`;
        this.reportNames$ = this.http.get(url);
  }
}
